import { useTranslation } from "react-i18next";
import ImageUrlProfile from "components/app/image-url/ImageUrlProfile";
import { Service } from "utils/services";
import { profileVerified } from "assets";
import LinkifyText from "components/app/linkify/LinkifyText";
import { MessageType } from "utils/enum/message_type";
import { commentTimeAgo } from "utils/formatTimeSecondToHour";

export default function NewFeedOneComment({ post, onOpenDialogNewFeedPost }: { post: any; onOpenDialogNewFeedPost: (post: any) => void }) {
  const { t } = useTranslation();

  if (!post) return <></>;
  if (Service.toInteger(post?.comment_count) === 0)
    return (
      <div className="flex flex-row justify-between items-start space-x-2 mb-1 border-t border-gray-300 pt-2 ">
        <ImageUrlProfile isLinkProfile={false} user={Service.userAuth} className="rounded-full w-7 h-7" alt="logo" />
        <div className="flex flex-1 p-3 cursor-pointer bg-muted rounded-lg" onClick={() => onOpenDialogNewFeedPost(post)}>
          <p className="text-sm"> {t("Write a 1 st comment")}</p>
        </div>
      </div>
    );

  const comment = post?.comments[0] || null;

  return (
    <div className="flex flex-row justify-between items-start space-x-2 mb-1 ">
      <div className="flex flex-col mt-2 mb-2">
        <div className="flex flex-row space-x-2 w-full items-start justify-start">
          <ImageUrlProfile isLinkProfile={true} user={comment?.sender} className={`cursor-pointer rounded-full w-7 h-7`} alt="logo" />
          <div className="flex flex-col space-y-2 w-full">
            <div className={`flex flex-col  rounded-lg  py-1   self-start w-auto ${comment?.comment !== "" && comment?.comment ? "bg-muted px-2" : ""}`}>
              <p className="flex flex-row font-medium items-center text-sm">
                {`${comment?.sender?.name!}`}
                {comment?.sender?.is_verified === "Yes" ? (
                  <>
                    <img
                      src={profileVerified}
                      alt=""
                      className="ml-1"
                      style={{
                        width: 10,
                        height: 10,
                      }}
                    />
                  </>
                ) : (
                  <></>
                )}
              </p>

              {comment?.comment !== "" && comment?.comment ? <LinkifyText key={comment?.comment_id} text={comment?.comment} /> : <></>}
            </div>
            {comment?.id === 0 ? (
              <p className="text-sm text-gray-400">Posting...</p>
            ) : (
              <>
                {MessageType.getType(comment?.comment_type) === MessageType.sticker ? <img src={comment?.comment_url} alt="sicker" className="w-16 h-16" /> : <></>}
                <div className="flex flex-row space-x-3 items-center">
                  <p className="font-medium text-xs ">{commentTimeAgo(comment?.comment_datetime)}</p>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

